import { Events } from '@service/events.service';
import { Directive, ElementRef } from '@angular/core';
import { fromEvent } from 'rxjs';

import * as $ from 'jquery';

@Directive({
  selector: '[btnloader]'
})
export class BtnloaderDirective {

  constructor(button: ElementRef, events: Events) {

    fromEvent(button.nativeElement, 'click').subscribe(() => {

      if ($(button.nativeElement).data('loader')) {
        let html = $(button.nativeElement).text();

        $(button.nativeElement)
          .addClass('disabled')
          .attr('disabled', 'disabled')
          .attr('data-inner', html)
          .html('<i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Aguarde...');
      }

    });

    events.on('btnpreloader').subscribe(() => {
      let html = $(button.nativeElement).data('inner');

      $(button.nativeElement)
          .removeClass('disabled')
          .removeAttr('disabled')
          .html(html);
    });
  }

}
